import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { AppState } from "@app/reducers";
import { CrudService, fileUrlDownload, IApplicationResponse, ModulesBasedApiSuffix, RxjsService, setRequiredValidator, SnackbarService } from "@app/shared";
import { DealerAvsDocumentDetailModel, DealerModuleApiSuffixModels } from "@modules/dealer";
import { loggedInUserData } from "@modules/others";
import { UserLogin } from "@modules/others/models";
import { select, Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/api";

@Component({
  selector: 'app-dealer-credit-vetting',
  templateUrl: './dealer-credit-vetting-component.html',
  styleUrls: ['./dealer-credit-vetting-component.scss', '../dealer-documents-add-edit/dealer-documents-add-edit.component.scss']
})
export class DealerCreditVettingComponent implements OnInit {

  loggedUser: any;
  btnName = 'Proceed';
  options = {
    hasNeedle: true,
    needleColor: 'gray',
    needleUpdateSpeed: 1000,
    arcColors: ["rgb(255,84,84)", "rgb(239,214,19)", "rgb(61,204,91)"],
    arcDelimiters: [35, 70],
    rangeLabel: ['0', '900'],
    needleStartValue: 10,
  }
  needleValue2: Number = 0;
  bottomLabel2: any;
  name2: any = '';
  centralLabel2 = '600';
  btnName2 = 'Proceed';
  options2 = {
    hasNeedle: true,
    needleColor: 'gray',
    needleUpdateSpeed: 1000,
    arcColors: ["rgb(255,84,84)", "rgb(239,214,19)", "rgb(61,204,91)"],
    arcDelimiters: [35, 70],
    rangeLabel: ['0', '900'],
    needleStartValue: 10,
  }
  principleDetails: any = {
    dealerPrincipleNameandsurname: '',
    principleIDNumber: '',
    dealerAddress: '',
    dateOfBirth: null,
    reason: '',
  };
  dealerPrincipleId;
  avscheckDetails;
  dealerAvsDocumentDialogForm: FormGroup;
  isSubmitted: boolean = false;
  fileName: any;
  showDocError: boolean;

  constructor(private store: Store<AppState>, private crudService: CrudService, public config: DynamicDialogConfig,
    public ref: DynamicDialogRef, private rxjsService: RxjsService, private formBuilder: FormBuilder,
    private snackbarService: SnackbarService) {
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.loggedUser = userData;
    });
  }

  ngOnInit(): void {
    this.dealerPrincipleId = this.config.data.row.dealerPrincipleId;
    this.options2.rangeLabel = ['0', '900'];
    this.initForm();
    this.getCrdeitVetting();
  }

  initForm(dealerAvsDocumentDetailModel?: DealerAvsDocumentDetailModel) {
    let DealerDocumentModel = new DealerAvsDocumentDetailModel(dealerAvsDocumentDetailModel);
    this.dealerAvsDocumentDialogForm = this.formBuilder.group({});
    Object.keys(DealerDocumentModel).forEach((key) => {
      this.dealerAvsDocumentDialogForm.addControl(key, new FormControl(this.config?.data?.row ? this.config?.data?.row[key] : DealerDocumentModel[key]));
    });
    this.dealerAvsDocumentDialogForm = setRequiredValidator(this.dealerAvsDocumentDialogForm, ["fileName"]);
  }
  getCrdeitVetting() {
    this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.CREDIT_VETTING, this.dealerPrincipleId, false,
      null)
      .subscribe((response: IApplicationResponse) => {
        if (response.statusCode == 200 && response.resources) {
          this.principleDetails = response.resources;
          this.principleDetails.dateOfBirth = new Date(response.resources.dateOfBirth);
          this.needleValue2 = (parseFloat(this.principleDetails.creditScore) / 900) * 100;
          this.bottomLabel2 = 'Score :' + this.principleDetails.creditScore;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }
  btnCloseClick() {
    this.ref.close(false);
  }

  onFileSelected(file) {
    this.dealerAvsDocumentDialogForm.get('fileName').markAsDirty();
    if (file?.length) {
      const fileObj = file.item(0);
      const fileType = fileObj.type;
      const fileExtension = fileObj.name.split('.').pop().toLowerCase();
      if (fileType.includes('video/')) {
        return this.snackbarService.openSnackbar("Please do not upload video files");
      }
      const forbiddenExtensions = ['apk', 'ipa'];
      if (forbiddenExtensions.includes(fileExtension)) {
        return this.snackbarService.openSnackbar("APK and iOS files are not allowed.");
      }
      var fileSize = fileObj?.size; // size in bytes
      var maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (fileSize > maxSize) {
        return this.snackbarService.openSnackbar(`File size exceeds the allowed limit of 10MB.`);
      }
      this.showDocError = false;
      const fileName = fileObj.name;
      // if (fileExtension !== '.xlsx') {
      // this.snackbarService.openSnackbar("Please select .xlsx file extension only", ResponseMessageTypes.WARNING);
      //  return;
      // }
      if (fileName) {
        this.dealerAvsDocumentDialogForm.get('fileName').setValue(fileName);
      }
      this.fileName = fileObj;
    } else if (!this.dealerAvsDocumentDialogForm.get('fileName').value) {
      this.showDocError = true;
    }
  }

  onOpenDocument() {
    if (this.principleDetails?.fileName) {
      fileUrlDownload(this.principleDetails?.documentUrl, this.principleDetails?.fileName, false, this.crudService, this.rxjsService);
    }
  }

  onSubmitDialog() {
    if (this.isSubmitted || !this.dealerAvsDocumentDialogForm?.valid) {
      this.dealerAvsDocumentDialogForm?.markAllAsTouched();
      return;
    } else if (!this.dealerAvsDocumentDialogForm.dirty) {
      this.snackbarService.openSnackbar("No Changes were detected");
      return;
    } else if (!this.dealerAvsDocumentDialogForm.getRawValue()?.fileName) {
      this.snackbarService.openSnackbar("Please upload any file");
      return;
    }
    const obj = this.dealerAvsDocumentDialogForm.getRawValue();
    let formData = new FormData();
    formData.append("file", this.fileName);
    formData.append('Obj', JSON.stringify(obj));
    this.rxjsService.setDialogOpenProperty(true);
    this.rxjsService.setFormChangeDetectionProperty(true); // Form submitt No changes snackbar prevent
    this.isSubmitted = true;
    this.crudService.create(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_CREDIT_VETTING_DOCUMENT, formData)
      .subscribe((res: IApplicationResponse) => {
        if (res?.isSuccess == true && res?.statusCode == 200) {
          this.dealerAvsDocumentDialogForm.reset();
          this.ref.close(res);
        }
        this.rxjsService.setDialogOpenProperty(false);
        this.isSubmitted = false;
      })
  }
}